const ACTIVITIES_COLLECTION = 'activities';
const ACTIVITIES_COLLECTION_TEST = 'activitiesTest';
export {ACTIVITIES_COLLECTION, ACTIVITIES_COLLECTION_TEST};
